const ProductsSection = () => {
  return (
    <section id="products" class="products">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="headline text-center mb-5">
              <h2 class="pb-3 position-relative d-inline-block">
                TOP PRINTER DEALS & ESSENTIALS
              </h2>
            </div>
          </div>
        </div>
        <div class="row">
          {/* <!-- Product 1 --> */}
          <div class="col-sm-6 col-lg-4">
            <a
              href="/product/wireless-printer"
              class="d-block text-center mb-4"
            >
              <div class="product-list">
                <div class="product-image position-relative">
                  <span class="sale">Limited Offer</span>
                  <img
                    decoding="async"
                    src="/assets/img/p2.jpg"
                    alt="Wireless Printer"
                    class="img-fluid product-image-first"
                  />
                  <img
                    decoding="async"
                    src="/assets/img/p2.jpg"
                    alt="Wireless Printer Side View"
                    class="img-fluid product-image-secondary"
                  />
                </div>
                <div class="product-name pt-3">
                  <h3 class="text-capitalize">All-in-One Wireless Printer</h3>
                  <p class="mb-0 amount">
                    $400.00 <del>$580.00</del>
                  </p>
                  <div class="py-1">
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star"></span>
                  </div>
                  {/* <!-- Button with link --> */}
                  <a href="/product/1" class="btn btn-blue mt-3">
                    BUY NOW
                  </a>
                </div>
              </div>
            </a>
          </div>

          {/* <!-- Product 2 --> */}
          <div class="col-sm-6 col-lg-4">
            <a href="/product/laser-printer" class="d-block text-center mb-4">
              <div class="product-list">
                <div class="product-image position-relative">
                  <img
                    decoding="async"
                    src="/assets/img/p3.jpg"
                    alt="Laser Printer"
                    class="img-fluid product-image-first"
                  />
                  <img
                    decoding="async"
                    src="/assets/img/p3.jpg"
                    alt="Laser Printer Back View"
                    class="img-fluid product-image-secondary"
                  />
                </div>
                <div class="product-name pt-3">
                  <h3 class="text-capitalize">High-Speed Laser Printer</h3>
                  <p class="mb-0 amount">$300.00</p>
                  <div class="py-1">
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star"></span>
                    <span class="ti-star"></span>
                  </div>
                  <a href="/product/2" class="btn btn-blue mt-3">
                    BUY NOW
                  </a>
                </div>
              </div>
            </a>
          </div>

          {/* <!-- Product 3 --> */}
          <div class="col-sm-6 col-lg-4">
            <a href="/product/ink-cartridges" class="d-block text-center mb-4">
              <div class="product-list">
                <div class="product-image position-relative">
                  <img
                    decoding="async"
                    src="/assets/img/p4.jpg"
                    alt="Ink Cartridges"
                    class="img-fluid product-image-first"
                  />
                  <img
                    decoding="async"
                    src="/assets/img/p4.jpg"
                    alt="Ink Cartridges Pack"
                    class="img-fluid product-image-secondary"
                  />
                </div>
                <div class="product-name pt-3">
                  <h3 class="text-capitalize">
                    Genuine Ink & Toner Cartridges
                  </h3>
                  <p class="mb-0 amount">$60.00</p>
                  <div class="py-1">
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                  </div>
                  <a href="/product/3" class="btn btn-blue mt-3">
                    BUY NOW
                  </a>
                </div>
              </div>
            </a>
          </div>

          {/* <!-- Product 4 --> */}
          <div class="col-sm-6 col-lg-4">
            <a href="/product/a4-paper" class="d-block text-center mb-4">
              <div class="product-list">
                <div class="product-image position-relative">
                  <img
                    decoding="async"
                    src="/assets/img/p5.jpg"
                    alt="Printer Paper"
                    class="img-fluid product-image-first"
                  />
                  <img
                    decoding="async"
                    src="/assets/img/p5.jpg"
                    alt="Printer Paper Pack"
                    class="img-fluid product-image-secondary"
                  />
                </div>
                <div class="product-name pt-3">
                  <h3 class="text-capitalize">Premium A4 Printer Paper</h3>
                  <p class="mb-0 amount">$20.00</p>
                  <div class="py-1">
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star"></span>
                    <span class="ti-star"></span>
                    <span class="ti-star"></span>
                  </div>
                  <a href="/product/4" class="btn btn-blue mt-3">
                    BUY NOW
                  </a>
                </div>
              </div>
            </a>
          </div>

          {/* <!-- Product 5 --> */}
          <div class="col-sm-6 col-lg-4">
            <a href="/product/photo-printer" class="d-block text-center mb-4">
              <div class="product-list">
                <div class="product-image position-relative">
                  <img
                    decoding="async"
                    src="/assets/img/p6.jpg"
                    alt="Photo Printer"
                    class="img-fluid product-image-first"
                  />
                  <img
                    decoding="async"
                    src="/assets/img/p6.jpg"
                    alt="Photo Printer in Use"
                    class="img-fluid product-image-secondary"
                  />
                </div>
                <div class="product-name pt-3">
                  <h3 class="text-capitalize">Portable Photo Printer</h3>
                  <p class="mb-0 amount">$150.00</p>
                  <div class="py-1">
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star active"></span>
                    <span class="ti-star"></span>
                    <span class="ti-star"></span>
                  </div>
                  <a href="/product/5" class="btn btn-blue mt-3">
                    BUY NOW
                  </a>
                </div>
              </div>
            </a>
          </div>

          {/* <!-- Product 6 --> */}
          <div class="col-sm-6 col-lg-4">
            <a
              href="/product/color-laser-printer"
              class="d-block text-center mb-4"
            >
              <div class="product-list">
                <div class="product-image position-relative">
                  <span class="sale">Best Seller</span>
                  <img
                    decoding="async"
                    src="/assets/img/p5.jpg"
                    alt="Color Laser Printer"
                    class="img-fluid product-image-first"
                  />
                  <img
                    decoding="async"
                    src="/assets/img/p6.jpg"
                    alt="Color Laser Printer Side View"
                    class="img-fluid product-image-secondary"
                  />
                </div>
                <div class="product-name pt-3">
                  <h3 class="text-capitalize">Color LaserJet Printer</h3>
                  <p class="mb-0 amount">
                    $550.00 <del>$700.00</del>
                  </p>
                  <a href="/product/6" class="btn btn-blue mt-3">
                    BUY NOW
                  </a>
                </div>
              </div>
            </a>
          </div>
        </div>

        {/* <!-- UP TO 75% Off Section --> */}
        <div class="overflow-hidden my-5">
          <div class="row">
            <div class="col-sm-12 up_to_off">
              <img
                decoding="async"
                src="/assets/img/lg.jpg"
                alt="Printer Sale Banner"
                class="img-fluid w-100"
              />
              <div class="up_to_content">
                <h2>UP TO 75% OFF - PRINTERS, INK & SUPPLIES!</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ProductsSection;
